import {
  SET_SIGN_UP_LOADING,
  SET_SIGN_UP_SUCCESS,
  SET_SIGN_UP_ERROR,
  SET_SIGN_IN_LOADING,
  SET_SIGN_IN_SUCCESS,
  SET_SIGN_IN_ERROR,
  SET_SIGN_OUT,
  SET_POST_BIO_LOADING,
  SET_POST_BIO_SUCCESS,
  SET_POST_BIO_ERROR,
  SET_SIGN_UP_SUCCESS_LOADING
} from '../../Constants/action-types';

const initialState = {
  signUpLoading: false,
  signUpSuccess: false,
  signUpError: false,
  errorCode: '',

  signInLoading: false,
  signInSuccess: false,
  signInError: false,
  isLoggedin: false,

  postBioLoading: false,
  postBioSuccess: false,
  postBioError: false
};

export default function signInReducer(state = initialState, action) {
  switch (action.type) {
    case SET_SIGN_UP_LOADING:
      return {
        ...state,
        signUpLoading: true,
        signUpSuccess: false,
        signUpError: false,
        errorCode: ''
      };
    case SET_SIGN_UP_SUCCESS:
      return {
        ...state,
        signUpLoading: false,
        signUpSuccess: true,
        signUpError: false,
        errorCode: ''
      };
    case SET_SIGN_UP_SUCCESS_LOADING:
      return {
        ...state,
        signUpLoading: action.bool,
        signUpSuccess: false,
        signUpError: false,
        errorCode: ''
      };
    case SET_SIGN_UP_ERROR:
      return {
        ...state,
        signUpLoading: false,
        signUpSuccess: false,
        signUpError: true,
        errorCode: action.errorCode
      };

    case SET_SIGN_IN_LOADING:
      return {
        ...state,
        signInLoading: true,
        signInSuccess: false,
        signInError: false
      };
    case SET_SIGN_IN_SUCCESS:
      return {
        ...state,
        signInLoading: false,
        signInSuccess: true,
        signInError: false,
        isLoggedin: true
      };
    case SET_SIGN_IN_ERROR:
      return {
        ...state,
        signInLoading: false,
        signInSuccess: false,
        signInError: true
      };

    case SET_SIGN_OUT:
      return {
        ...state,
        isLoggedin: false
      };
    case SET_POST_BIO_LOADING:
      return {
        ...state,
        postBioLoading: true,
        postBioSuccess: false,
        postBioError: false
      };
    case SET_POST_BIO_SUCCESS:
      return {
        ...state,
        postBioLoading: false,
        postBioSuccess: true,
        postBioError: false
      };
    case SET_POST_BIO_ERROR:
      return {
        ...state,
        postBioLoading: false,
        postBioSuccess: false,
        postBioError: true
      };
    default:
      return state;
  }
}
